// extracted by mini-css-extract-plugin
export default {"container":"Error_container__UIFj8","content":"Error_content__l4xBo"};